/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as LabelerDefs from './defs.defs.js'

const $nsid = 'app.bsky.labeler.getServices'

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  dids: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'did' })),
  detailed: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.boolean(), false),
  ),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  views: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<LabelerDefs.LabelerView>(
          (() => LabelerDefs.labelerView) as any,
        ),
        /*#__PURE__*/ l.typedRef<LabelerDefs.LabelerViewDetailed>(
          (() => LabelerDefs.labelerViewDetailed) as any,
        ),
      ],
      false,
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get information about a list of labeler services. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

export const $lxm = $nsid
